export const LoginBackground = (): JSX.Element => {
    return (
        <>
            <div className="absolute -z-1 h-full w-full bg-neutral-50"></div>
            <div
                className="pointer-events-none fixed inset-0 -z-1"
                style={{
                    clipPath: "polygon(100% 0, 40% 100%, 100% 100%)",
                    background: "#FCF4B9",
                }}
            />
            <div
                className="pointer-events-none fixed inset-0 -z-1"
                style={{ clipPath: "polygon(0 0, 0 100%, 60% 100%)", background: "#FEEF87" }}
            />
        </>
    );
};
